import React, { useState, useEffect } from 'react';
import { X, User, Briefcase, MapPin, Mail, Download } from 'lucide-react';
const API = 'https://talentflow-backend-production-09dd.up.railway.app/api';

export default function AdminBenchPanel({ resource, token, onClose }) {
  const [candidates, setCandidates] = useState([]);

  useEffect(() => {
    if (resource) loadCandidates();
  }, [resource]);

  const loadCandidates = async () => {
    try {
      const r = await fetch(`${API}/candidates?benchResourceId=${resource._id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const d = await r.json();
      if (d.success) setCandidates(d.candidates || []);
    } catch {}
  };

  if (!resource) return null;

  const colors = ['#6366f1','#8b5cf6','#ec4899','#f59e0b','#10b981'];
  const avatarColor = colors[resource.name?.charCodeAt(0) % colors.length];

  const statusMap = {
    pending: { bg:'#fef9c3', color:'#a16207', label:'Pending Review' },
    ai_interview_pending: { bg:'#dbeafe', color:'#1d4ed8', label:'Interview Pending' },
    ai_interview_done: { bg:'#e0f2fe', color:'#0369a1', label:'Interview Done' },
    approved: { bg:'#dcfce7', color:'#15803d', label:'Approved' },
    rejected: { bg:'#fee2e2', color:'#b91c1c', label:'Rejected' },
  };
  const st = statusMap[resource.approvalStatus] || statusMap.pending;

  return (
    <>
      <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:400}}/>
      <div style={{position:'fixed',right:0,top:0,bottom:0,width:'480px',background:'white',zIndex:401,boxShadow:'-20px 0 60px rgba(0,0,0,0.15)',overflowY:'auto',display:'flex',flexDirection:'column'}}>
        <div style={{background:'linear-gradient(135deg,#1a1a2e,#16213e)',padding:'24px',flexShrink:0}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
            <div style={{display:'flex',gap:'14px',alignItems:'center'}}>
              <div style={{width:'52px',height:'52px',borderRadius:'12px',background:avatarColor,display:'flex',alignItems:'center',justifyContent:'center',color:'white',fontWeight:'800',fontSize:'20px',flexShrink:0}}>
                {resource.isAnonymous ? '?' : resource.name?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <div style={{color:'white',fontWeight:'700',fontSize:'18px'}}>{resource.isAnonymous ? 'Anonymous' : resource.name}</div>
                <div style={{color:'rgba(255,255,255,0.6)',fontSize:'13px',marginTop:'2px'}}>{resource.title}</div>
                <span style={{display:'inline-block',background:st.bg,color:st.color,fontSize:'10px',fontWeight:'700',padding:'2px 10px',borderRadius:'20px',marginTop:'6px'}}>{st.label}</span>
              </div>
            </div>
            <button onClick={onClose} style={{background:'rgba(255,255,255,0.1)',border:'none',color:'white',borderRadius:'8px',padding:'6px',cursor:'pointer'}}>
              <X size={18}/>
            </button>
          </div>
        </div>

        <div style={{padding:'20px',flex:1}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'10px',marginBottom:'20px'}}>
            <div style={{background:'#f8fafc',borderRadius:'10px',padding:'12px',textAlign:'center'}}>
              <div style={{fontWeight:'800',fontSize:'18px',color:'#0f172a'}}>{resource.experience}y</div>
              <div style={{color:'#94a3b8',fontSize:'10px',marginTop:'2px'}}>Experience</div>
            </div>
            <div style={{background:'#f8fafc',borderRadius:'10px',padding:'12px',textAlign:'center'}}>
              <div style={{fontWeight:'800',fontSize:'14px',color:'#0f172a'}}>₹{resource.rate >= 1000 ? (resource.rate/1000).toFixed(0)+'k' : resource.rate}</div>
              <div style={{color:'#94a3b8',fontSize:'10px',marginTop:'2px'}}>{resource.rateType}</div>
            </div>
            <div style={{background:resource.availability==='immediate'?'#dcfce7':'#f8fafc',borderRadius:'10px',padding:'12px',textAlign:'center'}}>
              <div style={{fontWeight:'800',fontSize:'11px',color:resource.availability==='immediate'?'#15803d':'#0f172a'}}>{resource.availability==='immediate'?'Now':resource.availability}</div>
              <div style={{color:'#94a3b8',fontSize:'10px',marginTop:'2px'}}>Available</div>
            </div>
          </div>

          {resource.aiScore && (
            <div style={{background:'linear-gradient(135deg,#ede9fe,#dbeafe)',borderRadius:'10px',padding:'14px',marginBottom:'16px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div>
                <div style={{color:'#4c1d95',fontSize:'12px',fontWeight:'600'}}>AI Interview Score</div>
                <div style={{color:'#64748b',fontSize:'11px',marginTop:'2px'}}>{resource.interviewCompleted ? 'Completed' : 'Pending'}</div>
              </div>
              <div style={{color:'#4c1d95',fontSize:'28px',fontWeight:'800'}}>{resource.aiScore}<span style={{fontSize:'14px'}}>/10</span></div>
            </div>
          )}

          <div style={{background:'#f8fafc',borderRadius:'12px',padding:'16px',marginBottom:'16px',border:'1px solid #e2e8f0'}}>
            <div style={{fontWeight:'700',fontSize:'13px',color:'#0f172a',marginBottom:'12px',display:'flex',alignItems:'center',gap:'6px'}}><Briefcase size={14}/> Vendor Details</div>
            <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
              <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                <User size={13} color="#94a3b8"/>
                <span style={{color:'#374151',fontSize:'13px',fontWeight:'600'}}>{resource.vendor?.name || 'N/A'}</span>
              </div>
              {resource.vendor?.email && (
                <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                  <Mail size={13} color="#94a3b8"/>
                  <span style={{color:'#6366f1',fontSize:'12px'}}>{resource.vendor.email}</span>
                </div>
              )}
            </div>
          </div>

          {resource.skills?.length > 0 && (
            <div style={{marginBottom:'16px'}}>
              <div style={{fontWeight:'700',fontSize:'13px',color:'#0f172a',marginBottom:'8px'}}>Skills</div>
              <div style={{display:'flex',gap:'6px',flexWrap:'wrap'}}>
                {resource.skills.map(s => <span key={s} style={{padding:'4px 10px',background:'#ede9fe',color:'#5b21b6',borderRadius:'6px',fontSize:'12px',fontWeight:'500'}}>{s}</span>)}
              </div>
            </div>
          )}

          {resource.summary && (
            <div style={{marginBottom:'16px'}}>
              <div style={{fontWeight:'700',fontSize:'13px',color:'#0f172a',marginBottom:'6px'}}>Summary</div>
              <p style={{color:'#64748b',fontSize:'13px',lineHeight:'1.6',margin:0,background:'#f8fafc',padding:'12px',borderRadius:'8px'}}>{resource.summary}</p>
            </div>
          )}

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'16px'}}>
            {resource.location && <div style={{background:'#f8fafc',borderRadius:'8px',padding:'10px'}}>
              <div style={{color:'#94a3b8',fontSize:'11px',marginBottom:'4px',display:'flex',alignItems:'center',gap:'4px'}}><MapPin size={11}/> Location</div>
              <div style={{color:'#0f172a',fontSize:'13px',fontWeight:'600'}}>{resource.location}</div>
            </div>}
            {resource.education && <div style={{background:'#f8fafc',borderRadius:'8px',padding:'10px'}}>
              <div style={{color:'#94a3b8',fontSize:'11px',marginBottom:'4px'}}>Education</div>
              <div style={{color:'#0f172a',fontSize:'13px',fontWeight:'600'}}>{resource.education}</div>
            </div>}
          </div>

          {candidates.length > 0 && (
            <div style={{marginBottom:'16px'}}>
              <div style={{fontWeight:'700',fontSize:'13px',color:'#0f172a',marginBottom:'8px'}}>Requirements Applied ({candidates.length})</div>
              <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
                {candidates.map(c => (
                  <div key={c._id} style={{background:'#f8fafc',borderRadius:'8px',padding:'10px 14px',border:'1px solid #e2e8f0'}}>
                    <div style={{color:'#0f172a',fontSize:'13px',fontWeight:'600'}}>{c.requirement?.title || 'N/A'}</div>
                    <div style={{display:'flex',gap:'8px',marginTop:'4px',alignItems:'center'}}>
                      <span style={{fontSize:'11px',padding:'2px 8px',borderRadius:'4px',background:'#dbeafe',color:'#1d4ed8',fontWeight:'600'}}>{c.status}</span>
                      {c.aiScore && <span style={{fontSize:'11px',color:'#64748b'}}>Score: {c.aiScore}/10</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{display:'flex',gap:'10px',marginTop:'8px'}}>
            {resource.vendor?.email && (
              <a href={`mailto:${resource.vendor.email}`} style={{flex:1,padding:'10px',background:'#f1f5f9',color:'#374151',border:'1px solid #e2e8f0',borderRadius:'8px',textDecoration:'none',fontSize:'13px',fontWeight:'600',display:'flex',alignItems:'center',justifyContent:'center',gap:'6px'}}>
                <Mail size={14}/> Contact Vendor
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
